"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdFormik = require("cccisd-formik");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _style = _interopRequireDefault(require("./style.css"));
var _InfoLabel = _interopRequireDefault(require("../InfoLabel"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var EditForm = function EditForm(props) {
  var initialValues = props.initialValues();
  var validate = function validate(values) {
    var errors = {};
    var regex = /^(?:http(s)?:\/\/)[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/;
    if (!values.url || values.url === '') {
      errors.url = 'URL is required';
    } else if (!regex.test(values.url)) {
      errors.url = "Must include protocol. E.g., 'https://www.google.com' instead of 'www.google.com'";
    }
    if (values["short"] !== initialValues["short"]) {
      if (values["short"].length < 4) {
        errors["short"] = 'Short Code must be at least 4 characters';
      } else if (!/^[a-zA-Z0-9_]+$/.test(values["short"])) {
        errors["short"] = 'Short Code may only contain letters, numbers, and underscores';
      }
    }
    return errors;
  };
  var tooltip = 'Edit the custom short code for the URL.  It must be at least 4 characters and may only contain letters, numbers, and underscores.';
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
    validate: validate,
    onSubmit: props.handleSubmit,
    initialValues: initialValues,
    render: function render() {
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "url",
        component: _cccisdFormik.CccisdInput,
        label: "URL*"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].infoIcon
      }, /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
        tooltip: tooltip
      })), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "short",
        component: _cccisdFormik.CccisdInput,
        label: "Short Code*"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].optional1
      }, /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
        optional: true
      })), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "label",
        component: _cccisdFormik.CccisdInput,
        label: "Label"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].optional2
      }, /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
        optional: true
      })), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "description",
        component: _cccisdFormik.CccisdTextarea,
        label: "Description"
      }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("button", {
        className: "btn btn-primary",
        type: "submit"
      }, "Submit")));
    }
  }));
};
EditForm.propTypes = {
  handleSubmit: _propTypes["default"].func,
  initialValues: _propTypes["default"].func
};
var _default = exports["default"] = EditForm;